import React, {Component} from 'react';
import Table from "../../components/Table/Table";
import {showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import moment from "moment";
import {Col, Row} from "reactstrap";
import HakedisModal from "./HakedisModal";
import SweetAlert from "react-bootstrap-sweetalert";
import Alert from "react-s-alert";
import TextOverFlowTooltip from "../../components/TextOverFlowTooltip";
import SendMultiplePayTrModal from "./SendMultiplePayTrModal";
import HakedisStateModal from "./HakedisStateModal";
import ExcelExporter from "../../components/ExcelExporter";
import './ProggressPayment.css'
import {defterUnitName, defterUnitNameShort} from "../../helper/permission";
import {EntegratorConf} from "../../constants";
import SendInvoiceMailModal from "../../components/mail/SendInvoiceMailModal";
import {EntegratorIdentifiers} from "../../helper/enums";
import SendFileModal from "./SendFileModal";

class HakedisList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            manual: false,
            content: [],
            total: 0,
            loading: false,
            searching: false,
            searchQuery: undefined,
            page: 0,
            size: 10,
            distributors: [],
            distributorMap:[],
            parentCustomerId:-1,
            hakedisModal:false,
            sendMultipleInvoiceModal:false,
            updateModal:false,
        };
        this.fetchData     = this.fetchData.bind(this);
        this.handleSearch  = this.handleSearch.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
        this.downloadExcel = this.downloadExcel.bind(this);
        this.updateState = this.updateState.bind(this);
        this.handleSortChange = this.handleSortChange.bind(this);
    }

    fetchData(accessor, direction, page, size) {
        let self = this;
        let sortStr = accessor !== undefined ? ('&sort=' + accessor + ',' + direction) : '&sort=createdAt,desc';
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;

        let params = {
            url: '/progresspayment/fetchMonitoring/?page=' + page + '&size=' + size + searchQuery + sortStr,
            method: "get",
        };

        self.setState({ loading: true, searching: true, manual: self.manual === true ? false : self.manual });

        request(params)
            .then(function (response) {
                let filteredContent = response.data.content;

                if (self.props.isActive) {
                    filteredContent = filteredContent.filter(item => new Date(item.startDate) >= new Date("2025-01-01"));
                }
                let totalRecords = self.props.isActive ? filteredContent.length : response.data.totalElements;

                self.setState({
                    page: page,
                    size: size,
                    total: totalRecords,
                    content: filteredContent.map(item => ({
                        ...item,
                        mailState: item.mailState
                    })),
                    loading: false,
                    searching: false
                });

            }).catch(function (error) {
            self.setState({ loading: false, searching: false });
            showAxiosError(error);
        });
    }

    handleSearch(searchQuery) {
        this.setState({
            searchQuery,
            searching: true
        }, () => this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size))
    }

    confirmDelete(){
        let self = this;
        let params = {
            url: `/progresspayment/delete`,
            method: "post",
            data:self.state.selectedItem.recordId
        };
        self.setState({deleteBtnDisabled:true});
        request(params)
            .then(function (response) {
                Alert.success(response.data, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
                self.setState({manual:true,showDeleteSwal:false,selectedItem:null,deleteBtnDisabled:false});
            }).catch(function (error) {
            showAxiosError(error);
            self.setState({deleteBtnDisabled:false})
        });
    }

    updateState(row){
        this.setState({updateModal:true, row:row});
    }

    downloadExcel(item){
        let self = this;
        let data = {
            recordId: item.recordId,
            identifier: item.distributor?.vknTckn,
            startDate: item.startDate,
            finishDate: item.finishDate
        }
        let params = {
            url: `/progresspayment/downloadExcel`,
            method: "post",
            data:data,
            responseType: 'arraybuffer'
        };
        request(params)
            .then(function (response) {
                let blob = new Blob([response.data], {type: response.headers["content-type"]});
                let urlCreator = window.URL || window.webkitURL;
                let url = urlCreator.createObjectURL(blob);
                let a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = url;
                a.download = response.headers['filename'];
                a.click();
                self.setState({showLoading:false, selectedItem:null});
            }).catch(function (error) {
            showAxiosError(error);
            self.setState({deleteBtnDisabled:false})
        });
    }

    handleSortChange(accessor, direction) {
        this.setState({
            sortAccessor: accessor,
            sortDirection: direction
        }, () => this.fetchData(accessor, direction, this.state.page, this.state.size));
    }

    render() {

        let flag = this.props.currentUser &&
            (this.props.currentUser.entegrator || this.props.currentUser.distributor) &&
            this.props.currentUser.adminUser;

        const columnsDefault = [
            {
                accessor: [
                    {Header: "VKN/TCKN", accessor: "distributor.vknTckn"},
                    {Header: "Ünvan", accessor: "distributor.customerName"}
                ],
                Cell: row => (<div style={{textAlign: "center"}}>
                    {row.distributor.vknTckn}<br/>
                    {<TextOverFlowTooltip text={row.distributor.customerName} maxLength={20}/>}
                </div>)
            },
            {
                accessor: [
                    { Header: "Başlangıç Tarihi", accessor: "startDate"},
                    { Header: "Bitiş Tarihi", accessor: "finishDate" }
                ],
                Cell: row => (
                    <div style={{ textAlign: "center" }}>
                        {moment(row.startDate).isValid() ? moment(row.startDate).format("DD-MM-YYYY") : ''}<br />
                        {moment(row.finishDate).isValid() ? moment(row.finishDate).format("DD-MM-YYYY") : ''}
                    </div>
                )
            },

            {
                accessor: [
                    {Header: "Hakediş Oranı(Kontör)", accessor: "creditPercentage"},
                    {Header: "Hakediş Oranı("+defterUnitName(EntegratorConf.identifier)+")", accessor: "storagePercentage"},
                ],
                Cell: row => (<div style={{textAlign: "center"}}>
                    {row.creditPercentage}<br/>
                    {row.storagePercentage}
                </div>)
            },
            {
                accessor: [
                    {Header: "Kontör Adeti", accessor: "totalCreditPurchase"},
                    {Header: defterUnitName(EntegratorConf.identifier), accessor: "totalStoragePurchase"},
                ],
                Cell: row => (<div style={{textAlign: "center"}}>
                    {row.totalCreditPurchase  + " Adet"}<br/>
                    {row.totalStoragePurchase + " " + defterUnitNameShort(EntegratorConf.identifier)}
                </div>)
            },
            {
                accessor: [
                    {Header: "Kontör Tutarı", accessor: "totalCreditAmount"},
                    {Header: defterUnitName(EntegratorConf.identifier)+" Tutarı", accessor: "totalStorageAmount"}
                ],
                Cell: row => (<div style={{textAlign: "center"}}>
                    {row.totalCreditAmount}<br/>
                    {row.totalStorageAmount}
                </div>)
            },
            {
                accessor: [
                    {Header: "Hakediş Tutarı", accessor: "totalAmount"},
                    {Header: "Aktif Müşteri Sayısı", accessor: "activeCustomerCount"}
                ],
                Cell: row => (<div style={{textAlign: "center"}}>
                    {row.totalAmount}<br/>
                    {row.activeCustomerCount}
                </div>)
            },
            {
                accessor: [
                    {Header: "Türü", accessor: "isMonthly"},
                    {Header: "Çalışma Şekli", accessor: "distributor.workType"}

                ],
                Cell: row => (<div style={{textAlign: "center"}}>
                    {row.isMonthly ? "Aylık Hakediş" : ""}<br/>
                    {(row.distributor.workType === 1 ? "Müşteri Kendi Öder": "")}
                    {(row.distributor.workType === 2 ? "Bayi Müşteri Adına Öder": "")}
                    {(row.distributor.workType === 3 ? "Bayi Toplu Kontor Alır": "")}
                </div>)
            },
            {
                accessor: [
                    {Header: "Oluşturulma Zamanı", accessor: "createdAt"},
                    {Header: "Güncelleme Zamanı", accessor: "updatedAt"}
                ],
                Cell: row => (<div style={{textAlign: "center"}}>
                    {moment(row.createdAt).isValid() ? moment(row.createdAt).format("DD-MM-YYYY HH:mm:ss") : ''}<br/>
                    {moment(row.updatedAt).isValid() ? moment(row.updatedAt).format("DD-MM-YYYY HH:mm:ss") : ''}
                </div>)
            },
            {
                accessor: [
                    {Header: "Durum", accessor: "state.description"},
                    {Header: "Mail Durumu", accessor: "mailState"}
                ],
                Cell: row => (<div style={{textAlign: "center"}}>
                    {row.isMonthly ? row.state.description: ""}<br/>
                    {row.mailState === 'Gönderildi' ? 'Gönderildi' : 'Gönderilmedi'}
                </div>)
            },
            {
                Header:
                    <button type="button" className="TekBtn edit pull-right"
                            style={{
                                float: 'right',
                                marginRight: '7px',
                                background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'
                            }}
                            onClick={() => this.setState({ hakedisModal: true })}>
                        Hakediş Hesapla
                    </button>,
                accessor: "",
                sortable: false,
                width: "11%",
                Cell: (row) => (
                    <div className="btn-group">
                        <div className="dropdown">
                            <button className="MenuBtn2 listt btn btn-default" type="button" data-toggle="dropdown">Seçİnİz
                            </button>
                            <div className="dropdown-menu" aria-labelledby={"dropdownMenuButton_" + row.recordId}>
                                <a className="dropdown-item" onClick={() => this.downloadExcel(row)}> <i className="fa fa-file-excel"/>Excel'e Aktar</a>
                                {!row.isMonthly &&
                                    <a className="dropdown-item" onClick={() =>this.setState({showDeleteSwal:true,selectedItem:row})}> <i className="fa fa-trash-alt"/>Sil</a>
                                }
                                {this.props.currentUser.entegrator &&
                                    <a className="dropdown-item" onClick={() => this.updateState(row)}> <i
                                        className="fa fa-refresh"/>Durum Güncelle</a>
                                }
                                {[EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART, EntegratorIdentifiers.MBT].includes(EntegratorConf.identifier) &&
                                    this.props.currentUser.entegrator &&
                                    <a className="dropdown-item"
                                       onClick={() => this.setState({selectedItem: row, mailModal: true})}>
                                        <i className="fa fa-envelope"/>E-posta Gönder</a>
                                }

                                {row.distributor.workType === 1 && (
                                    <a className="dropdown-item"
                                       onClick={() => this.setState({selectedItem: row, fileUploadModal: true})}>
                                        <i className="fa fa-send"/> Dosya Gönder
                                    </a>
                                )}

                            </div>
                        </div>
                    </div>
                )
            }
        ];
        const columnsRestricted = [
            {
                accessor: [
                    { Header: "Başlangıç Tarihi", accessor: "startDate" },
                    { Header: "Bitiş Tarihi", accessor: "finishDate" }
                ],
                Cell: row => (
                    <div style={{ textAlign: "center" }}>
                        {moment(row.startDate).isValid() ? moment(row.startDate).format("DD-MM-YYYY") : ''}<br />
                        {moment(row.finishDate).isValid() ? moment(row.finishDate).format("DD-MM-YYYY") : ''}
                    </div>
                )
            },
            {
                accessor: [
                    { Header: "Hakediş Tutarı", accessor: "totalAmount" },
                    { Header: "Durum", accessor: "state.description" }
                ],
                Cell: row => (
                    <div style={{ textAlign: "center" }}>
                        {row.totalAmount}<br />
                        {row.state.description}
                    </div>
                )
            },
            {
                accessor: "actions",
                sortable: false,
                width: "11%",
                Cell: row => (
                    <div className="btn-group">
                        <div className="dropdown">
                            <button className="MenuBtn2 listt btn btn-default" type="button" data-toggle="dropdown">
                                Seçiniz
                            </button>
                            <div className="dropdown-menu" aria-labelledby={"dropdownMenuButton_" + row.recordId}>
                                <a className="dropdown-item" onClick={() => this.downloadExcel(row)}>
                                    <i className="fa fa-file-excel"/> Excel'e Aktar
                                </a>
                                <a className="dropdown-item"
                                   onClick={() => this.setState({selectedItem: row, fileUploadModal: true})}>
                                    <i className="fa fa-send"/> Dosya Gönder
                                </a>
                            </div>
                        </div>
                    </div>
                )
            }
        ];
        const selectedColumns = this.props.isActive ? columnsRestricted : columnsDefault;

        const defaultFields = [
            {
                label: "VKN/TCKN",
                accessor: "distributor.vknTckn",
                type: "numericText",
                operator: "="
            },
            {
                label: "Ünvan",
                accessor: "distributor.customerName",
                type: "text",
                operator: "="
            },
            {
                label: "Hakediş Oranı(Kontör)",
                accessor: "creditPercentage",
                type: "text",
                operator: "="
            },
            {
                label: "Kontör Adeti",
                accessor: "totalCreditPurchase",
                type: "numericText",
                operator: "="
            },
            {
                label: "Kontör Tutarı",
                accessor: "totalCreditAmount",
                type: "text",
                operator: "="
            },
            {
                label: "Aktif Müşteri Sayısı",
                accessor: "activeCustomerCount",
                type: "numericText",
                operator: "="
            },
            {
                label: "Başlangıç Tarihi",
                accessor: "startDate",
                type: "date",
                operator: "="
            },
            {
                label: "Bitiş Tarihi",
                accessor: "finishDate",
                type: "date",
                operator: "="
            },
            {
                label: "Durum",
                accessor: "state.recordId",
                type: "select",
                operator: "=",
                selectData: [
                    {value: null, label: 'Tümü'},
                    {value: '1',  label: 'FATURALANDIRMA BEKLİYOR'},
                    {value: '2',  label: 'FATURALANDIRMA TAMAMLANDI, ÖDEME BEKLİYOR'},
                    {value: '3',  label: 'ÖDEME TAMAMLANDI'}
                ]
            },
            {
                label: "Çalışma Şekli",
                accessor: "distributor.workType",
                type: "select",
                operator: "=",
                selectData: [
                    {value: null, label: "Tümü"},
                    {value: 1, label: "Müşteri Kendi Öder"},
                    {value: 2, label: "Bayi Müşteri Adına Öder"},
                    {value: 3, label: "Bayi Toplu Kontor Alır"}
                ]
            },
        ];
        const filteredFields = this.props.isActive
            ? defaultFields.filter(field =>
                ["startDate", "finishDate", "totalAmount", "state.recordId"].includes(field.accessor)
            )
            : defaultFields;

        return (
            <Col sm="12">
                <div className="card-body">
                    {flag &&
                        <Row>
                            <Col sm='12' style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}>
                                {!this.props.isActive && (
                                    <ExcelExporter position="leftSide"
                                                   sheetName='Hakediş_Listesi'
                                                   title="Hakediş Hareketlerini Düzenle ve Excel'e Aktar"
                                                   customExport={true}
                                                   defaultHeaders={this.props.defaultheadersHakedis}
                                                   type='progressPaymentHakedis'
                                                   url='/progresspayment/monitoringExportXls'
                                                   instantDownload={true}
                                                   distributors={this.props.distributors}
                                                   icon='excel'
                                                   className='excelButton'
                                                   modalHeader='Hakediş Hareketlerini Düzenle ve Excele Aktar'
                                                   impersonateUserRoleId={this.props.impersonateUserRoleId}
                                    />
                                )}
                                {!this.props.isActive && (
                                    <button type="button" className="TekBtn edit pull-right"
                                            style={{
                                                float: 'right',
                                                marginRight: '7px',
                                                background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'
                                            }}
                                            onClick={() => this.setState({sendMultipleInvoiceModal: true})}>
                                        Hakediş Faturalandır
                                    </button>
                                )}

                            </Col>
                        </Row>
                    }
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="" style={{marginTop: '10px', marginBottom: '10px'}}
                                 id="HakedisDetailedContainer">
                                <DetailedSearch fields={filteredFields}
                                                loading={this.state.searching}
                                                onSearch={this.handleSearch} hasContainer="HakedisDetailedContainer"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className=" row">
                        <div className="col-sm-12" style={{float: 'right'}}>

                        </div>
                    </div>
                    <div className=" row">
                        <div className="col-sm-12">
                            <Table columns={selectedColumns}
                                   loading={this.state.loading}
                                   loadingText="Kayıtlar getiriliyor..."
                                   content={this.state.content}
                                   total={this.state.total}
                                   page={this.state.page}
                                   manual={this.state.manual}
                                   size={this.state.size}
                                   options={["5", "10", "20", "50", "100"]}
                                   fetchData={this.fetchData}
                                   onSortChange={this.handleSortChange}
                            />
                        </div>
                    </div>
                </div>
                {(this.state.hakedisModal) &&
                    <HakedisModal show={this.state.hakedisModal}
                                  distributors={this.props.distributors}
                                  toggle={(manual)=>this.setState({hakedisModal:false, manual})}/>
                }
                {(this.state.updateModal) &&
                    <HakedisStateModal show={this.state.updateModal}
                                       row={this.state.row}
                                       toggle={(manual)=>this.setState({updateModal:false, manual,row:null})}/>
                }
                {this.state.mailModal &&
                    <SendInvoiceMailModal
                        year={this.state.year}
                        month={this.state.month}
                        type="progressPaymentHakedis"
                        selected={this.state.selectedItem}
                        toggleModal={(flag) => this.setState({mailModal: flag})}
                        postUrl={`/progresspayment/sendMail/${this.state.selectedItem.recordId}`}
                        mailModal={this.state.mailModal}
                        fetchData={() => this.fetchData(this.state.sortAccessor, this.state.sortDirection, this.state.page, this.state.size)}
                    />
                }

                {this.state.showDeleteSwal &&
                    <SweetAlert
                        showCancel
                        closeOnClickOutside={false}
                        hideOverlay={false}
                        disabled={this.state.deleteBtnDisabled}
                        confirmBtnText="Evet"
                        confirmBtnCssClass="TekBtn gonder"
                        confirmBtnStyle={{float: 'right'}}
                        cancelBtnText="Hayır"
                        cancelBtnCssClass="TekBtn vazgec"
                        cancelBtnStyle={{
                            background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
                            float: 'left'
                        }}
                        confirmBtnBsStyle="success"
                        cancelBtnBsStyle="default"
                        title="Silme Onayı"
                        style={{width: 400}}
                        onConfirm={this.confirmDelete}
                        onCancel={(e) => this.setState({showDeleteSwal: false})}
                    >
                        Silme işlemini onaylıyor musunuz?
                    </SweetAlert>
                }
                {(this.state.sendMultipleInvoiceModal) &&
                    <SendMultiplePayTrModal modal={this.state.sendMultipleInvoiceModal}
                                            toggleModal={(manual)=>this.setState({sendMultipleInvoiceModal:false, manual})}
                                            path="progresspayment"/>
                }

                {this.state.fileUploadModal && this.state.selectedItem && (
                    <SendFileModal
                        show={this.state.fileUploadModal}
                        toggleModal={(flag) => this.setState({ fileUploadModal: flag })}
                        selected={{
                            recordId: this.state.selectedItem.recordId,
                            vknTckn: this.state.selectedItem.distributor?.vknTckn
                        }}
                    />
                )}


            </Col>
        );
    }
}

export default HakedisList;
